import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33498f81"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "output__item-block"
}
const _hoisted_2 = {
  key: 1,
  class: "output__item-block"
}
const _hoisted_3 = ["onClick"]

import { SettingsStore, useSettingsStore } from '@/store/settings';
import { onMounted, ref, toRefs, watch } from 'vue';

interface ListOutputItemProps {
  settingsIndex: number;
  settingsItemIndex: number;
  mixed?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListOutputBlocks',
  props: {
    settingsIndex: {},
    settingsItemIndex: {},
    mixed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const { settingsIndex, settingsItemIndex, mixed = false } = toRefs(props);

const settingsStore: SettingsStore = useSettingsStore();

const { settings, deleteBlock, deleteBlockByColor } = settingsStore;

const onBlockClick = () => {
  deleteBlock(settingsIndex.value, settingsItemIndex.value);
};

const onMixedBlockClick = (color: string) => {
  deleteBlockByColor(settingsIndex.value, color);
};

const mixedArr = ref<string[] | null>(null);

const shuffleArr = (arr: string[]) => {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
};

const createMixedArr = () => {
  if (mixed) {
    settings[settingsIndex.value].forEach((option) => {
      for (let i = 1; i <= option.count; i++) {
        if (option.visibility) {
          if (mixedArr.value?.length) {
            mixedArr.value.push(option.color);
          } else {
            mixedArr.value = [option.color];
          }
        }
      }
    });
    if (mixedArr.value) {
      mixedArr.value = shuffleArr(mixedArr.value);
    }
  }
};

onMounted(() => {
  createMixedArr();
});

watch(settings[settingsIndex.value], () => {
  mixedArr.value = null;
  createMixedArr();
});

return (_ctx: any,_cache: any) => {
  return (!_unref(mixed) && _unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].visibility)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([...Array(_unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].count)], (_, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "block",
            key: index,
            onClick: onBlockClick,
            style: _normalizeStyle({ background: _unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].color })
          }, null, 4))
        }), 128))
      ]))
    : (_unref(mixed) && mixedArr.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mixedArr.value, (color, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "block",
              onClick: () => onMixedBlockClick(color),
              key: index,
              style: _normalizeStyle({ background: color })
            }, null, 12, _hoisted_3))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}
}

})